var map = {
	"./arch_1.svg": "d7e9",
	"./arch_2.svg": "727a",
	"./arrow-down.svg": "f66a",
	"./arrow-top.svg": "ad83",
	"./bbazis.svg": "eddf",
	"./calendar.svg": "287d",
	"./chat.svg": "a485",
	"./close-map.svg": "a68a",
	"./close.svg": "864a",
	"./day.svg": "0fb3",
	"./down-arrow.svg": "127c",
	"./download.svg": "039a",
	"./dragpan.svg": "3252",
	"./elem_22.svg": "28b1",
	"./example.svg": "b6f9",
	"./facebook-flat.svg": "76b6",
	"./facebook.svg": "ca4d",
	"./filter.svg": "3663",
	"./grid.svg": "a8cb",
	"./igla.svg": "ea27",
	"./inresize.svg": "cecc",
	"./instagram.svg": "8d62",
	"./layer.svg": "e595",
	"./left-arrow-crm.svg": "8009",
	"./left-arrow.svg": "5d26",
	"./line_bottom_green.svg": "9058",
	"./line_genplan.svg": "3fa1",
	"./list.svg": "3561",
	"./logn_arrow.svg": "fff6",
	"./long-arrow.svg": "e797",
	"./loop.svg": "2416",
	"./mail.svg": "8ca3",
	"./map_bazis.svg": "140f",
	"./map_pin.svg": "f276",
	"./minus.svg": "ae17",
	"./monitor.svg": "f71f",
	"./moon.svg": "a1d9",
	"./mouse-wheel.svg": "3d1e",
	"./move-map.svg": "4831",
	"./move.svg": "35ac",
	"./phone-call.svg": "1db8",
	"./phone.svg": "b470",
	"./pin.svg": "f937",
	"./plane.svg": "3740",
	"./plus.svg": "701f",
	"./print.svg": "bdd0",
	"./resize-gal.svg": "41aa",
	"./resize.svg": "739e",
	"./resize_noll.svg": "e3c2",
	"./right-arrow.svg": "ce12",
	"./share.svg": "2296",
	"./telegram-flat.svg": "8f50",
	"./telegram.svg": "fd92",
	"./unresize.svg": "efcd",
	"./vk-flat.svg": "8646",
	"./vk.svg": "22ec",
	"./vorona.svg": "2cb6",
	"./whatsapp-flat.svg": "6594",
	"./whatsapp_flat.svg": "fb6f",
	"./youtube.svg": "1f50",
	"./zoom.svg": "d534"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";